<template>
  <el-dialog
    title="修改默认密码"
    :visible.sync="passwordDialog"
    width="50rem"
    class="dialog"
    :before-close="clearFormData"
    :close-on-click-modal="false"
    :show-close="false"
    :close-on-press-escape="false"
  >
    <div class="flex-column flex-center">
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        class="phone-form"
        label-width="160px"
        label-suffix="："
        size="small"
      >
        <el-form-item label="当前密码" prop="currentPassword">
          <el-input
            v-model.trim="passwordForm.currentPassword"
            placeholder="请输入当前密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model.trim="passwordForm.newPassword"
            placeholder="请输入新密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="再次确认新密码" prop="confirmPassword">
          <el-input
            v-model.trim="passwordForm.confirmPassword"
            placeholder="请再次确认新密码"
            show-password
          />
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="changeDefaultPassword">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
// 引入api接口
import { editPasswordApi } from '@/api/user'

// 引入数据字典
import { isOldAccountDict, isDefaultPasswordDict } from '@/dictionary/user'

import { mapState, mapActions } from 'vuex'
import { passwordRegularValid } from '@/utils/form-validate'

export default {
  name: 'DefaultPasswordChange',

  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      }
      callback()
    }

    return {
      passwordDialog: false,

      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        currentPassword: [
          {
            required: true,
            message: '请输入当前密码',
            trigger: ['blur', 'change']
          }
        ],
        newPassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: ['blur', 'change']
          },
          passwordRegularValid
        ],
        confirmPassword: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: ['blur', 'change']
          },
          {
            validator: validateConfirmPassword,
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    ...mapState('user', ['isOldAccount', 'isDefaultPassword'])
  },

  watch: {
    isDefaultPassword() {
      this.showChangeDefaultPasswordDialog()
    }
  },

  created() {
    this.showChangeDefaultPasswordDialog()
  },

  methods: {
    ...mapActions('user', ['getEmployeeInfo']),

    // 是否展示修改密码弹窗
    showChangeDefaultPasswordDialog() {
      if (this.isDefaultPassword == isDefaultPasswordDict.YES.value) {
        this.passwordDialog = true
      } else {
        this.passwordDialog = false
      }
    },

    // 修改默认密码
    changeDefaultPassword() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) {
          this.$message.error('表单填写错误，请按照提示填写')
          return
        }

        editPasswordApi(this.passwordForm)
          .then(res => {
            this.$message.success('默认密码修改成功')

            this.getEmployeeInfo()
              .then(() => {
                this.clearFormData()
              })
              .catch(err => {
                this.$message.error(err.message)
              })
          })
          .catch(err => {
            this.$message.error(err.message)
          })
      })
    },

    // 弹窗消失清除表单数据
    clearFormData() {
      this.passwordDialog = false
      this.$refs.passwordForm.resetFields()
      this.$refs.passwordForm.clearValidate()
    }
  }
}
</script>

<style lang="scss" scoped>
.phone-form {
  width: 100%;
}
</style>
